import React from 'react';
import { useFormContext } from 'react-hook-form';
import PhotoUploader from '../../../PhotoUploader/PhotoUploader';

const PhotosSection = () => {
  const { setValue, watch } = useFormContext();
  
  // Get current photos from form
  const pickupPhotos = watch('pickup.images') || [];
  const deliveryPhotos = watch('delivery.images') || [];

  // Handle photos change
  const handlePickupPhotosChange = (photos) => {
    setValue('pickup.images', photos, { shouldDirty: true, shouldValidate: false });
  };

  const handleDeliveryPhotosChange = (photos) => {
    setValue('delivery.images', photos, { shouldDirty: true, shouldValidate: false });
  };

  // Handle deleted keys tracking
  const handlePickupDeletedKey = (deletedKey) => {
    const currentDeleted = watch('deletedPickupImages') || [];
    if (!currentDeleted.includes(deletedKey)) {
      const newDeleted = [...currentDeleted, deletedKey];
      setValue('deletedPickupImages', newDeleted, { shouldDirty: true });
    }
  };

  const handleDeliveryDeletedKey = (deletedKey) => {
    const currentDeleted = watch('deletedDeliveryImages') || [];
    if (!currentDeleted.includes(deletedKey)) {
      const newDeleted = [...currentDeleted, deletedKey];
      setValue('deletedDeliveryImages', newDeleted, { shouldDirty: true });
    }
  };


  return (
    <>
      <PhotoUploader
        title="Pickup Photos"
        photos={pickupPhotos}
        onPhotosChange={handlePickupPhotosChange}
        onDeletedKeysChange={handlePickupDeletedKey}
        maxFileSize={120}
        acceptedTypes="image/png,image/jpeg,image/jpg"
        showCount={true}
      />

      <PhotoUploader
        title="Delivery Photos"
        photos={deliveryPhotos}
        onPhotosChange={handleDeliveryPhotosChange}
        onDeletedKeysChange={handleDeliveryDeletedKey}
        maxFileSize={120}
        acceptedTypes="image/png,image/jpeg,image/jpg"
        showCount={true}
      />

    </>
  );
};

export default PhotosSection;

